import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { AccordionSection } from 'widgets/CallPopUp/ui/components/AccordionSection/AccordionSection'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { ContactsList } from 'widgets/CallPopUp/ui/components/ContactsList/ContactsList'
import { EndResumeActions } from 'widgets/CallPopUp/ui/components/ContactsList/parts'
import { HoldStatus } from 'widgets/CallPopUp/ui/components/BaseContent/HoldStatus/HoldStatus'

export const CallHoldContent = observer(() => {
  const { callPopUpOnHoldStore, innerRefTooltipCurrent } = useCallPopUpDefaultContext()
  const { items, count, handleResume, handleEnd, handleEndAll, resumePending } =
    callPopUpOnHoldStore

  return (
    <AccordionSection
      count={count}
      title={'On hold'}
      show
      showIconButton
      renderButton={
        <Button
          text={'End all'}
          typeBtn={'contained'}
          contained={'secondary'}
          intent={'destructive'}
          size={'small'}
          disabled={!count}
          onClick={handleEndAll}
        />
      }
    >
      <ContactsList
        items={items}
        ariaLabel={'OnHoldContactsList'}
        autoHeightMax={280}
        alwaysShowActions
        renderBottom={() => <HoldStatus />}
        renderActions={(item) => (
          <EndResumeActions
            item={item}
            onResume={(contact) => handleResume(contact.sid)}
            onEnd={(contact) => handleEnd(contact.sid)}
            resumeDisabled={resumePending}
            innerRefCurrent={innerRefTooltipCurrent || undefined}
          />
        )}
      />
    </AccordionSection>
  )
})
